export function setMenu(state, menu) {
    state.menu = menu;
}
